import { ActionRequestState, ActionRequestStateWithData, ActionType, BaseAction, HttpState, UserData } from '../../util/model';

interface State {
    userList: UserData[];
    userListState: HttpState;
    userCreateState: HttpState;
    userUpdateState: HttpState;
    userDeleteState: HttpState;
    userUpdatePasswordState: HttpState;
}

const intitialState: State = {
    userList: [],
    userListState: HttpState.Success,
    userCreateState: HttpState.Idle,
    userUpdateState: HttpState.Idle,
    userUpdatePasswordState: HttpState.Idle,
    userDeleteState: HttpState.Idle
}

export const userReducer = (state: State = intitialState, action: BaseAction): State => {
    if (action.type === ActionType.REQUEST_USER_LIST) {
        const a = action as ActionRequestStateWithData<UserData[]>;
        return {
            ...state,
            userList: a.payload,
            userListState: a.state
        }
    } else if(action.type === ActionType.REQUEST_CREATE_USER) {
        const a = action  as ActionRequestState;
        return {
            ...state,
            userCreateState: a.payload
        }
    } else if(action.type === ActionType.REQUEST_UPDATE_USER) {
        const a = action  as ActionRequestState;
        return {
            ...state,
            userUpdateState: a.payload
        }
    } else if(action.type === ActionType.REQUEST_UPDATE_USER_PASSWORD) {
        const a = action  as ActionRequestState;
        return {
            ...state,
            userUpdatePasswordState: a.payload
        }
    } else if(action.type === ActionType.REQUEST_DELETE_USER) {
        const a = action  as ActionRequestState;
        return {
            ...state,
            userDeleteState: a.payload
        }
    } else if(action.type === ActionType.CLEAR_USER_EDIT_CACHE) {
        return {
            ...state,
            userCreateState: HttpState.Idle,
            userUpdateState: HttpState.Idle,
            userUpdatePasswordState: HttpState.Idle,
            userDeleteState: HttpState.Idle
        }
    }
    return state;
}
